import { getCookieValue } from "../../cookieHelper";
import handleError from "../../errorHandler";
import { GET_NEWSFEED_API, GET_NEWSFEED_API_SUCCESS, GET_NEWSFEED_API_FAILURE, TRIGGER_TOAST } from "../constants";
import { GetNewsFeedData } from "./../../queries";

const getRandomData = (numberOfNewsFeedCards: number, lpSuggestArr: Array<any>, portalurl?: string) => {
  let randomFeed: any = [],
    notedIndecesArr: Array<number> = [];
  numberOfNewsFeedCards = lpSuggestArr.length >= numberOfNewsFeedCards ? numberOfNewsFeedCards : lpSuggestArr.length;
  if (lpSuggestArr && lpSuggestArr.length > 0) {
    for (let i = 0; i < numberOfNewsFeedCards; i++) {
      let randomIndex = Math.floor(Math.random() * (lpSuggestArr.length - 1 - 0 + 1) + 0);
      if (notedIndecesArr.indexOf(randomIndex) === -1) {
        notedIndecesArr.push(randomIndex);
        lpSuggestArr[randomIndex].portalurl = portalurl;
        randomFeed.push(lpSuggestArr[randomIndex]);
      } else {
        i = i - 1;
      }
    }
  }
  return randomFeed;
};

const getNewsFeedAPI = (portalLoginURL: string, numberOfNewsFeedCards: number) => {  
  return async (dispatch: any) => {
    dispatch({ type: GET_NEWSFEED_API });
    const request = {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Accept: "application/json",
        "x-access-token": `Bearer ${getCookieValue(`${process.env.REACT_APP_ENV === 'dynamic'?'stagingIdToken':(process.env.REACT_APP_ENV + 'IdToken')}`)}`,
      },
      body: JSON.stringify({ query: GetNewsFeedData() }),
    };
    const response = fetch(`${process.env["REACT_APP_NEWSFEEDGRAPHQLENDPOINT"]}`, request);
    response
      .then((response) => response.json())
      .then((newsFeedData: any) => {
        if (newsFeedData && newsFeedData.data) {
          let randomData = getRandomData(numberOfNewsFeedCards, newsFeedData.data.lpSuggest || [], portalLoginURL);
          dispatch({ type: GET_NEWSFEED_API_SUCCESS, payload: randomData });
        } else {
          getRandomData(numberOfNewsFeedCards, []);
          // handleError(err);
          dispatch({ type: GET_NEWSFEED_API_FAILURE });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity : 'error',
              transMessage: "message_errorDefault"
            },
          });
        }
      })
      .catch((err: any) => {
        getRandomData(numberOfNewsFeedCards, []);
        // handleError(err);
        dispatch({ type: GET_NEWSFEED_API_FAILURE });
        dispatch({
          type: TRIGGER_TOAST,
          payload: {
            shouldShow: true,
            severity : 'error',
            transMessage: "message_errorDefault"
          },
        });
      });
  };
};

export default {
  getNewsFeedAPI,
};
